module.exports = __webpack_public_path__ + "static/img/id-z.49aaa32a.png";